import React, { useEffect, useRef, useState } from 'react';
import ReactScrollWheelHandler from 'react-scroll-wheel-handler';
import { calcMessagePosition, calcWrapperScale, useMatchMedia } from '@utils';
import { breakpoints, links } from '@config';
import { AppLink, Icon, Text } from '@components';
import { useAnimationFinished } from './useAnimationFinished';
import * as S from './styles';

const MyTail: React.FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const catRef = useRef<HTMLDivElement>(null);
  const timeoutIdRef = useRef<any>(null);
  const [scale, setScale] = useState(1);
  const [messagePosition, setMessagePosition] = useState([0, 0]);
  const [messageShow, setMessageShow] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const animationFinished = useAnimationFinished(scrolled);
  const laptopMatch = useMatchMedia(breakpoints.laptop);

  const handleResize = () => {
    wrapperRef.current && setScale(calcWrapperScale(wrapperRef.current));
    catRef.current && setMessagePosition(calcMessagePosition(catRef.current));
  };

  const handleScroll = (direction: 'up' | 'down') => {
    setScrolled(direction === 'down');
    setMessageShow(false);
  };

  const handleCatClick = () => {
    setMessageShow(true);

    timeoutIdRef.current = setTimeout(() => {
      setMessageShow(false);
    }, 2000);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    clearTimeout(timeoutIdRef.current);
  }, [scrolled, timeoutIdRef]);

  useEffect(() => {
    catRef.current && setMessagePosition(calcMessagePosition(catRef.current));
  }, [catRef, animationFinished]);

  useEffect(() => {
    wrapperRef.current && setScale(calcWrapperScale(wrapperRef.current));
  }, [wrapperRef]);

  return (
    <ReactScrollWheelHandler
      upHandler={() => handleScroll('up')}
      downHandler={() => handleScroll('down')}
      wheelConfig={[5, 10, 0.05, 0]}
    >
      <S.Scene>
        <S.Title as={'h1'} textColor={'light'} scrolled={scrolled}>MyTail</S.Title>
        <S.Descr scrolled={scrolled}>
          <Text textColor={'light'} textSize={'lg'} textOpacity={0.65}>Leave a piece of your</Text>
          <Text textColor={'light'} textSize={'lg'}>memories</Text>
          <S.Links>
            <AppLink marketType={'app-store'} link={links.appStore} />
            <AppLink marketType={'play-market'} link={links.playMarket} />
          </S.Links>
        </S.Descr>
        <S.Contacts scrolled={scrolled}>
          <S.SocialLink link={links.instagram}>
            <Icon glyph={'instagram'} iconSize={40} />
          </S.SocialLink>
          <S.SocialLink link={links.discord}>
            <Icon glyph={'discord'} iconSize={40} />
          </S.SocialLink>
          <S.SocialLink link={links.twitter}>
            <Icon glyph={'twitter'} iconSize={40} />
          </S.SocialLink>
        </S.Contacts>
        {
          animationFinished
          && <S.Message position={messagePosition} show={scrolled || messageShow}>
            { scrolled ? 'Follow me! Meow...' : 'Hey! Meow...' }
            </S.Message>
        }
        <S.Arrow scrolled={scrolled} onClick={() => setScrolled(true)} />
        <S.Wrapper ref={wrapperRef} wrapperScale={scale}>
          <S.Background scrolled={scrolled} />

          {/* Пыль */}
          {
            laptopMatch // На ПК
            && <>
              <S.Speck />
              <S.SpeckDrop position={[5, 10]} length={50} duration={3} />
              <S.SpeckDrop position={[10, 50]} length={30} delay={0.5} duration={4} />
              <S.SpeckDrop position={[15, 60]} length={35} duration={3} />
              <S.SpeckDrop position={[22, 20]} length={40} duration={3} />
              <S.SpeckDrop position={[70, 20]} length={40} delay={0.5} duration={4} />
              <S.SpeckDrop position={[75, 10]} length={40} duration={3} />
              <S.SpeckDrop position={[80, 50]} length={30} duration={2} />
              <S.SpeckDrop position={[85, 20]} length={40} duration={4} />
              <S.SpeckDrop position={[95, 60]} length={30} duration={3} />
            </>
          }
          {
            !laptopMatch // На мобилке
            && <>
              <S.SpeckDrop position={[40, 10]} length={50} duration={3} />
              <S.SpeckDrop position={[55, 0]} length={50} delay={0.5} duration={3} />
            </>
          }
          {/* End Пыль*/}

          <S.Island scrolled={scrolled}>
            <S.Cat
              ref={catRef}
              onClick={handleCatClick}
            />
            { (!scrolled && animationFinished) && <S.CatGlare /> }

            {/* Мерцание фонарей */}
            <S.Light position={[50, 34]} />
            <S.Light position={[59.4, 30]} />
            <S.Light position={[62.3, 33]} delay={0.5} />
            <S.Light position={[64, 65]} />
            {/* END Мерцание фонарей */}

            {/* Дым на воде */}
            <S.SmokeLeft />
            <S.SmokeRight />
            {/* END Дым на воде */}

          </S.Island>
        </S.Wrapper>
      </S.Scene>
    </ReactScrollWheelHandler>
  );
};

export { MyTail };